import { SEND_AUTH_EMAIL } from '../actionTypes/LaunchNLearnActionTypes';

export const sendAuthEmail = (payload) => ({
    type: SEND_AUTH_EMAIL,
    payload,
});

export default sendAuthEmail;
